import type { FaireProductEntity } from "../../entity_types/product";

export const p_jpsr5z56rp: FaireProductEntity = {
  token: "p_jpsr5z56rp",
  type: "product",
  name: "Organic Facial Minis - Gifts under $10",
  brandToken: "b_ckbr0ozf",
  brandName: "LENORA Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/6525e06201ff419be9ec5af46cdd2f30995158ccbe8e607d05b2199150f75a40.jpeg",
  galleryImageUrls: [],
  priceDollars: 2.5,
  description:
    "Give a moment of calm. Lenora's skincare in mini sizes is ideal for travel and thoughtful gifting. Each package contains 8 grams of product (enough for around 2 uses). \n\nEntice your customers at checkout displaying these in a beautiful ceramic bowl or little wooden box. \n\nIngredients listed on each package. \n",
  tags: [],
  msrpDollars: 5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:54.914Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
